export const FETCH_GLOBAL_SEARCH_RESULT = "FETCH_GLOBAL_SEARCH_RESULT";
export const FETCH_GLOBAL_SEARCH_RESULT_SUCCESS = "FETCH_GLOBAL_SEARCH_RESULT_SUCCESS";
export const FETCH_GLOBAL_SEARCH_RESULT_FAILED = "FETCH_GLOBAL_SEARCH_RESULT_FAILED";
